// Contact.jsx
import React, { useRef, useState } from "react";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import "bootstrap/dist/css/bootstrap.min.css";
import emailjs from "@emailjs/browser";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopy } from "@fortawesome/free-regular-svg-icons";

import "./Contact.css";

const reviewsData = [
  {
    id: "r1",
    text: "As Founder of the nonprofit organization, The Chad Foundation for Athletes and Artists, I am very fortunate to have Tetiana working with us as a major player on our 'Web Development Team.' From Day 1 Tetiana has exhibited an impeccable work ethic, critical thinking in any task given or proposed, and highly creative solutions  ",
    author: "Arista Burtrum, ",
    sourceTitle: "Founder at The Chad Foundation for Athletes and Artists",
    readMoreUrl: "https://www.linkedin.com/in/tetiana-korchynska/",
  },
  {
    id: "r2",
    text: "As a co-founder and Product Director of Wikibusines, I am happy to have Tetiana as a part of our team. I would describe her as a devoted and reliable team player. Tetiana is an integral part of our company since she not only writes clean and reusable code but also has excellent design skills and a strong understanding ",
    author: "Roman Melnyk,",
    sourceTitle: "Product Director at Wikibusines",
    readMoreUrl: "https://www.linkedin.com/in/tetiana-korchynska/",
  },
  {
    id: "r3",
    text: "Incredibly efficient and proactive are the exact words to describe Tetiana. As a Head of HR Unit for Freelancers, and Tetiana’s direct manager, I can say for sure that it was a luck to have her in our team since she is the team player everyone is looking for – always ready to help and not afraid to ask for it if needed, knowing her role and responsibilities, and understanding how she can contribute to the general ",
    author: "Vita Cordoba, ",
    sourceTitle: "Head of HR for Freelancers At Trionika (Wentrum)",
    readMoreUrl: "https://www.linkedin.com/in/tetiana-korchynska/",
  },
];

function ReviewCard({ review }) {
  const { text, author, sourceTitle, readMoreUrl } = review;

  return (
    <Card className="review-card">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p>
            {text}{" "}
            {readMoreUrl && (
              <a
                href={readMoreUrl}
                target="_blank"
                rel="noreferrer"
                className="contact-read-more-reviews"
              >
                ... read more
              </a>
            )}
          </p>
          <footer className="blockquote-footer">
            {author}
            {sourceTitle && <cite title="Source Title"> {sourceTitle}</cite>}
          </footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

function Reviews({ items = [] }) {
  return (
    <div className="contact-reviews">
      {items.map((rv) => (
        <ReviewCard key={rv.id} review={rv} />
      ))}
    </div>
  );
}

const Contact = () => {
  const formRef = useRef();
  const [isSent, setIsSent] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_5ban4mv", "template_cmmahtk", formRef.current, {
        publicKey: "Q-xjSLW-oYj7nvq7C",
      })
      .then(
        () => {
          setIsSent(true);
          formRef.current.reset();
        },
        () => {
          setIsSent(false);
        },
      );
  };

  return (
    <div className="contact-layout">
      <div className="contact-section">
        <div className="contact-form">
          <Form ref={formRef} onSubmit={sendEmail}>
            <Form.Group className="mb-3" controlId="formMessage">
              <Form.Label className="form-header">
                Let's get in touch!
              </Form.Label>
              <Form.Control
                className="form-box"
                as="textarea"
                rows={5}
                name="message"
                required
                placeholder="Type your message here..."
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formEmail">
              <Form.Label className="form-second-label">
                Your email address
              </Form.Label>
              <Form.Control
                className="form-box"
                type="email"
                name="reply_to"
                required
                placeholder="example@gmail.com"
              />
            </Form.Group>

            <button type="submit" disabled={isSent}>
              {isSent ? "Thanks for your message!" : "SEND"}
            </button>
          </Form>

          <div className="contact-info">
            <p>
              Contact me at: <br />
              tanakorchynska@gmail.com{" "}
              <span
                onClick={() =>
                  navigator.clipboard.writeText("tanakorchynska@gmail.com")
                }
                style={{ cursor: "pointer" }}
              >
                <FontAwesomeIcon icon={faCopy} />
              </span>
            </p>

            <div className="contact-links">
              <a
                href="https://www.linkedin.com/in/tetiana-korchynska/"
                target="_blank"
                rel="noreferrer"
              >
                LinkedIn
              </a>
              <a
                href="https://github.com/Taniatos"
                target="_blank"
                rel="noreferrer"
              >
                GitHub
              </a>
              <a
                href="https://www.behance.net/0031c316"
                target="_blank"
                rel="noreferrer"
              >
                Behance
              </a>
            </div>
          </div>
        </div>

        <Reviews items={reviewsData} />
      </div>

      <div className="contact-right-label">
        <h1 className="contact-section-h1">————— C O N T A C T </h1>
      </div>
    </div>
  );
};

export default Contact;
